import React, { FC } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { Card } from '@mofid-securities/uikit';
import { Icon } from '@/components/atomic/Icon';
import { IBalanceCardProps } from '@/components/BalanceSlide';
import { UserStatusOnClickWrapper } from '@/userStatus/components';
import { classnames } from '@/utils/classnames';
import { HamiUserBalance } from './HamiUserBalance';
import { HamiUserBalanceMask } from './HamiUserBalanceMask';
import { HamiUserBalanceRefetch } from './HamiUserBalanceRefetch';

export interface IHamiBalanceSlideCardProps extends IBalanceCardProps {
  buttonProps?: TButtonProps;
  refetch: () => {};
  isFetching: boolean;
  isError: boolean;
  showBalance: boolean;
  setShowBalance: (__value: boolean) => void;
}

const HamiBalanceSlideCardNew: FC<IHamiBalanceSlideCardProps> = ({
  title,
  amount,
  currency = 'ریال',
  buttonTitle,
  buttonAction,
  className,
  isMasked,
  buttonProps,
  isFetching,
  refetch,
  onMaskChange,
  isError,
  showBalance,
  setShowBalance,
  ...rest
}) => {
  return (
    <Card
      className={classnames(
        'relative h-[185px] overflow-hidden rounded-2xl text-white',
        'bg-[rgb(39,20,135)] bg-gradient-to-br from-[rgba(39,20,135,1)] to-[rgba(40,183,187,1)] contrast-[160%] saturate-[70%]',
        className
      )}
      {...rest}
    >
      <div className="absolute left-0 top-0 z-0 h-full w-full bg-[url('https://s3.ir-thr-at1.arvanstorage.com/mofidapp/common/noise.webp')] opacity-30" />
      <div className="absolute left-0 top-0 z-[10] h-full w-full bg-[url('https://s3.ir-thr-at1.arvanstorage.com/mofidapp/common/pattern.png')] bg-[left_bottom] bg-repeat-x" />
      <div className={classnames('flex h-[130px] flex-col gap-2 py-2')}>
        <div className="z-30 flex flex-wrap justify-between">
          <Image
            alt="کارگزاری مفید"
            className="!h-7 object-contain"
            height={28}
            src="https://s3.ir-thr-at1.arvanstorage.com/mofidapp/logo/logo-1.webp"
            width={86}
          />
          {buttonTitle && buttonAction && (
            <UserStatusOnClickWrapper>
              <button
                {...buttonProps}
                className="flex h-7 items-center justify-center rounded-md border  border-white p-2 !pr-3 text-[10px] font-medium text-white"
                onClick={buttonAction}
              >
                {buttonTitle}
                <Icon icon="chevron_left" size={18} />
              </button>
            </UserStatusOnClickWrapper>
          )}
          <div className="mt-2 w-full text-sm font-medium">{title}</div>
        </div>
        <div className="flex flex-row-reverse items-center justify-between">
          <HamiUserBalance
            amount={amount}
            currency={currency}
            isMasked={isMasked}
          />
          <div className="z-50 flex w-fit items-center">
            <HamiUserBalanceMask
              refetch={refetch}
              setShowBalance={setShowBalance}
              showBalance={showBalance}
            />
            <HamiUserBalanceRefetch
              isError={isError}
              isFetching={isFetching}
              isMasked={isMasked}
              refetch={refetch}
              showBalance={showBalance}
              onMaskChange={onMaskChange}
            />
          </div>
        </div>
      </div>
      <Link
        className="absolute bottom-0 right-0 z-30 flex h-14 w-full cursor-pointer items-center border-t border-[#ffffff42] bg-[#004C6A66] px-4 text-xs font-medium md:text-sm"
        href="/?index=1&isMelliCard=true"
      >
        <Icon className="ml-2" icon="mofid_card_outline" size={20} />
        درخواست ملی کارت
        <Icon className="mr-auto" icon="chevron_left" size={20}></Icon>
      </Link>
    </Card>
  );
};
export default HamiBalanceSlideCardNew;
